import { A, useRouteData } from "@solidjs/router";
import { CMS } from "../../components/cms/cms";
import { createStore } from "solid-js/store";
import { For, Show, onMount } from "solid-js";
import { loadAds, loadArtistIndexCms, setPageTitle, setSubMenu } from "../../app";
import slugify from "slugify";

type State = {
    isContentReady: boolean;
}
export type Finalist = {
    SalonEntrantId: number;
    FirstName: string;
    LastName: string;
    Country: string;
    DVI: boolean;
    Teens: boolean;
}
export function HomeArtistListingPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [listing, setListing] = createStore<Finalist[]>([]);
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setListing(routeData.listing);
        await loadArtistIndexCms();
        await loadAds("5th-arc-salon/introduction");
        setSubMenu("Artist Index");
        setPageTitle({ id: "5th-arc-salon/artist-index::title", text: "Artist Index" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="text-content">
                    <div class="container">
                        <CMS id="5th-arc-salon/artist-index::page-body">
                            <h1>
                                Finalists
                            </h1>
                            <p>
                                Congratulations to all of our 5<sup>th</sup> International ARC Salon Finalists.
                            </p>
                        </CMS>
                        <ul class="icon multicolumns">
                            <For each={listing}>{(item) =>
                                <li style={{ "font-size": "1rem" }}>
                                    <A href={`/artist/${slugify(item.FirstName + " " + item.LastName)}/${item.SalonEntrantId}`}>
                                        {item.FirstName} <b>{item.LastName}</b>
                                    </A>
                                    <Show when={item.Country}>
                                        &nbsp;({item.Country})
                                    </Show>
                                </li>
                            }</For>
                        </ul>
                    </div>
                </div>
            </Show>
        </>
    )
}